import type { Todo } from "../../domain/entities.ts";

export interface TimelineRelation { task?: Todo; direction: "blocked-by" | "blocks" }
export function timelineRelations(selected: Todo, tasks: Todo[]): TimelineRelation[] {
  const available=tasks.filter(task=>task.rootId===selected.rootId && !task.deleted && !task.archivedAt);
  return [...(selected.dependencyIds || []).map(id=>({task:available.find(task=>task.id===id),direction:"blocked-by" as const})),...available.filter(task=>(task.dependencyIds || []).includes(selected.id)).map(task=>({task,direction:"blocks" as const}))];
}

/** Purely decorative: the selected task's textual relationship list is the accessible equivalent. */
export function drawTimelineDependencies(section: HTMLElement, selected: Todo, tasks: Todo[]): void {
  section.querySelector("[data-timeline-lines]")?.remove();
  const rows=section.querySelector<HTMLElement>(".collection-timeline__rows"); if (!rows) return;
  const bars=Array.from(rows.querySelectorAll<HTMLElement>("[data-timeline-bar]")).filter(bar=>bar.getClientRects().length);
  const center=bars.find(bar=>bar.dataset.id===selected.id); if (!center) return;
  const bounds=rows.getBoundingClientRect();
  const svg=section.ownerDocument.createElementNS("http://www.w3.org/2000/svg","svg"); svg.dataset.timelineLines=""; svg.setAttribute("aria-hidden","true"); svg.setAttribute("width",String(rows.scrollWidth)); svg.setAttribute("height",String(rows.scrollHeight));
  for (const relation of timelineRelations(selected,tasks).filter(item=>item.task).slice(0,20)) {
    const other=bars.find(bar=>bar.dataset.id===relation.task!.id); if (!other) continue;
    const from=(relation.direction === "blocked-by" ? other : center).getBoundingClientRect();
    const to=(relation.direction === "blocked-by" ? center : other).getBoundingClientRect();
    const x1=from.right-bounds.left, y1=from.top+from.height/2-bounds.top;
    const x2=to.left-bounds.left, y2=to.top+to.height/2-bounds.top;
    const bend=Math.max(x1+8,(x1+x2)/2);
    const path=section.ownerDocument.createElementNS("http://www.w3.org/2000/svg","path");
    path.setAttribute("d",`M ${x1} ${y1} H ${bend} V ${y2} H ${x2} m -4 -3 l 4 3 l -4 3`); svg.append(path);
  }
  rows.prepend(svg);
}
